<template>
<div class="chapter">
<div class="inner_page">
<div><img alt="image" class="img1" height="100%;" src="MSRCover.png"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// violentpolitics_cover.vue?975c71ec